export const NO_MORE_TODOS = 'Nothing else needs doing';
export const DELETE_ME = 'AirBnB rules need more than one export const';
